import styled from "styled-components";

import { typographyWeights } from "../constants/fontWeightOptions";
import { baseTextStyles } from "../shared/styled";

export const SecondarySmallBase = styled.h6`
  ${baseTextStyles}
  font-size: 16px;
  font-weight: ${props => typographyWeights[props.weight]};
  line-height: 24px;
`;
